import { template as template_ae54a084f8de4bed827a7c95ee1104f0 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { Model } from '../../routes/render/meta';
const { stringify } = JSON;
export default RouteTemplate(template_ae54a084f8de4bed827a7c95ee1104f0(`
  <pre>{{stringify @model null 2}}</pre>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
